"use strict";
/**
 * @restor/shared-utils — pure helpers with no platform dependencies.
 *
 * Nothing here may import from Node, a browser API, React or NestJS: the same
 * build is consumed by the backend, the web apps and the React Native courier
 * app (TZ §71).
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./money"), exports);
__exportStar(require("./phone"), exports);
__exportStar(require("./geo"), exports);
__exportStar(require("./datetime"), exports);
__exportStar(require("./strings"), exports);
__exportStar(require("./pagination"), exports);
__exportStar(require("./storefront"), exports);
//# sourceMappingURL=index.js.map